export default {
	'^INDEX$': 'Home',
	'.*INVENTORY_LISTING.*': 'Vehicle Listing',
	'.*HOURS.*': 'Hours & Directions',
	'.*DIRECTIONS.*': 'Hours & Directions',
	'.*INCENTIVES.*': 'OEM Incentives',
	'^AUTO_.*DETAILS.*': 'Vehicle Details',
	'.*404.*': 'Page Not Found',
	'.*SERVICE_LEAD.*': 'Service',
	'.*MAINTENANCE_MENU.*': 'Service',
	'.*SCHEDULE_SERVICE.*': 'Schedule Service',
	'.*MODEL_SPECIFIC_INDEX.*': 'Showroom',
	'.*SHOWROOM.*': 'Showroom',
	'.*PARTS_LEAD.*': 'Parts',
	'.*FINANCE_LEAD.*': 'Finance',
	'.*FINANCE_APPLICATION.*': 'Finance',
	'.*INCENTIVES_LISTING.*': 'OEM Incentives',
	'.*LEAD_TRADE_IN.*': 'Trade In',
	'.*PROMOTIONS_LISTING_PARTS.*': 'Parts Specials',
	'.*PROMOTIONS_LISTING_SERVICE.*': 'Service Specials',
	'.*SCHEDULE_AN_APPOINTMENT.*': 'Schedule Service',
	'.*SERVICE_ACCESSORIES.*': 'Accessories',
	'.*SERVICE_AIRFILTERS.*': 'Cabin Air Filter',
	'.*SERVICE_BATTERIES.*': 'Batteries',
	'.*SERVICE_BRAKES.*': 'Brakes',
	'.*SERVICE_CENTER.*': 'Service Home',
	'.*SERVICE_COURTESY_VEHICLES.*': 'Courtesy Vehicles',
	'.*SERVICE_MAINTENANCE.*': 'Maintenance',
	'.*SERVICE_PARTS(?!_SPECIALS).*': 'Parts',
	'.*SERVICE_PARTS_SPECIALS.*': 'Parts Specials',
	'.*SERVICE_PREMIUM_OIL.*': 'Premium Oil',
	'.*SERVICE_SPECIALS.*': 'Service Specials',
	'.*SERVICE_TIRES.*': 'Tire Store',
	'.*SPECIALS_LISTING_SERVICE.*': 'Service Specials',
	'.*SPECIALS_LISTING_PARTS.*': 'Dealer Specials',
	'.*SPECIALS_LISTING.*': 'Dealer Specials',
	'.*ABOUT_DEFAULT.*': 'About Us',
	'.*NEWS_DEFAULT.*': 'Blog',
	'.*CONTACT_DEFAULT.*': 'Contact Us',
	'.*STAFF_LISTING.*': 'About Us',
	'.*BLOG_VIDEO.*': 'Blog',
	'.*BROCHURE_DEFAULT.*': 'Brochure',
	'.*TEST_DRIVE.*': 'Test Drive',
	'.*WARRANTY.*': 'Warranty',
	'^DEFAULT$': 'Other',
	'.*SITEBUILDER_NEW_KIA_CARNIVAL_1.*': 'LandingPage_MY22Carnival page',
	'.*SITEBUILDER_BMWPLUGINHYBRID_1.*': 'PHEV Blitz'
};
